/* ==========================================================================
   SearcherFli > Client > Product > Openjaw > Row > RemoveButton
   ========================================================================== */

/* Modules */
const { addStyle, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Button = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');
const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');

const configuration = require('../../../../../config');

/* Render remove */
const renderRemoveButton = context => {
    return ButtonTemplate(
        addStyle(
            addData(
                {
                    icon: 'cancel',
                    content: ''
                },
                { type: configuration().type.removeButton }
            ),
            [configuration().css.removeButton]
        ),
        context
    );
};

/* Init */
function initRemoveButton(instance, index) {
    const panel = instance;

    /* Reference */
    panel.rows[index].removeButton = Button(
        `${instance.selector} [data-row='${index}'] [data-component=ButtonRxjs][data-type=${
            configuration().type.removeButton
        }]`
    );

    if (!panel.rows[index].removeButton) return;

    const removeButtonBefore = panel.rows[index - 1].removeButton;

    if (removeButtonBefore) removeButtonBefore.actions.disable();

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        [`click-remove-${index}`]: instance.rows[index].removeButton.events.click$.subscribe(e => {
            e.stopPropagation();

            if (removeButtonBefore) removeButtonBefore.actions.enable();

            instance.actions.removeRow(index);

            /* Logic for enable disable button add row */
            const { rows } = instance;
            if (rows.filter(item => item).length < 3) return;
            instance.addButton.actions.enable();
        })
    };
}

/* Destroy */
function destroyRemoveButton(instance, index) {
    if (!instance.rows[index].removeButton) return;

    const panel = instance;

    panel.rows[index].removeButton.actions.destroy();

    delete panel.rows[index].removeButton;

    panel.subscriptions[`click-remove-${index}`].unsubscribe();
    delete panel.subscriptions[`click-remove-${index}`];
}

/* Exports */
module.exports = {
    renderRemoveButton,
    initRemoveButton,
    destroyRemoveButton
};
